<template>
  <section id="main-container" style="background-color: rgb(230, 230, 230);">
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 sm8 md6 class="login-box pa-4" style="max-width: 420px; margin: 80px auto; border-radius: 5px;">
          <p v-if="error" class="mb-0">{{ error }}</p>
          <div v-else>
            <p class="mb-3">Completing sign-in…</p>
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { exchangeSsoSession } from "@/provider/authentication.js"

export default {
  name: "sso-callback",
  data() {
    return {
      error: ""
    }
  },
  async mounted() {
    const query = this.$route && this.$route.query ? this.$route.query : {}
    const code = query.code
    if (!code) {
      this.error = "SSO sign-in could not be completed."
      return
    }
    const result = await exchangeSsoSession(String(code))
    if (result.error) {
      this.error = result.message || "SSO sign-in could not be completed."
      return
    }
    const next = query.next || result.next
    await this.$store.dispatch("completeSsoLogin", {
      accessToken: result.accessToken,
      refreshToken: result.refreshToken,
      mfaPending: result.mfaPending,
      next: next
    })
  }
}
</script>
